import React from "react";

type Props = {
  percent: number;
  label?: string;
};

const McUploadProgress: React.FC<Props> = ({ percent, label }) => {
  const pct = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div
      className="mc-upload-progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      aria-label={label || "Upload progress"}
    >
      {label ? <div className="mc-upload-progress-label">{label}</div> : null}
      <div className="mc-upload-progress-track">
        <div className="mc-upload-progress-bar" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default McUploadProgress;
